import { ChangeDetectionStrategy, Component } from '@angular/core';

import { DsFormlyFieldType } from '@app/forms/formly/types/ds-formly-field';

@Component({
  selector: 'phone-field',
  templateUrl: './phone-field.component.html',
  styleUrls: ['./phone-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PhoneFieldComponent extends DsFormlyFieldType {}
